<template>
  <div class="selected-groups-section">
    <div class="data-title">sent to these groups</div>
    <div v-if="errorMessage"
         class="error-label text-center">{{errorMessage}}</div>

    <table v-if="onlySelectedGroups" class="selected-groups-table">
      <tbody>
      <template v-for="group in onlySelectedGroups">
        <tr :key="group.id" class="selected-groups-row">
          <td>{{group.name.replace(/\_/, ' ')}}</td>
          <td class="text-right">
            <group-name-tags :selectedNames="group.display_names"></group-name-tags>
          </td>
        </tr>
        <tr v-if="displayDate && subConfigsGroupNames && subConfigsGroupNames.includes(group.name)" :key="group.id + 'subfilter'">
          <td class="text-center">sub filters</td>
          <td class="text-right">({{displayDate}})</td>
        </tr>
        <tr v-if="subfilters[group.name]" :key="group.id + 'subfilter'">
          <td class="text-center">sub filters</td>
          <td class="text-right">{{subfilters[group.name]}}</td>
        </tr>
      </template>
      </tbody>
    </table>

  </div>
</template>

<script>
  import axiosConfig from '../../config/axios'
  import GroupNameTags from './GroupNameTags'
  import { isObject } from '../../utilities'
  import {format} from 'date-fns';
  import OnlySelectedGroups from '../../mixins/OnlySelectedGroupsMixin'
  import SubConfigDate from '../../mixins/SubConfigDateMixin'

  export default {
    props: {
      campaignId: [Number, String],
      selectedGroupsUrl: String,
    },

    name: 'SelectedGroups',

    components: {
      GroupNameTags,
    },

    mixins: [OnlySelectedGroups, SubConfigDate],

    data() {
      return {
        errorMessage: null,
        merchantSegmentIds: null,
        merchantTagIds: null,
        selectedGroups: null,
        showOnlySelected: true,
        subfilters: {
          categories: null,
          brands: null
        },
      }
    },

    methods: {
      formatTagSubfilterDisplay(tagSubfilter) {
        const end = tagSubfilter.max_date ? format(new Date(tagSubfilter.max_date), 'yyyy/MM/dd') : null,
          start = tagSubfilter.min_date ? format(new Date(tagSubfilter.min_date), 'yyyy/MM/dd') : null,
          maxSpend = tagSubfilter.max_spend ? +tagSubfilter.max_spend : null,
          minSpend = tagSubfilter.min_spend ? +tagSubfilter.min_spend : null

        let string = ""

        if(start && end) {
          string += `(${start} - ${end})`
        }

        if (minSpend && maxSpend) {
          string += `($${minSpend} - $${maxSpend})`
        } else if (minSpend) {
          string += `(≥ $${minSpend})`
        } else if (maxSpend) {
          string += `(≤ $${maxSpend})`
        }
        
        return string
      },

      loadSelectedGroups() {
        let errorMessage = `could not load the filters`

        axiosConfig.get(`/api/v3/campaigns/${this.campaignId}/selected_groups?legacy=true`)
          .then((response) => {
            const data = response.data
            if (isObject(data)) {
              this.setGroupsData(data)
              errorMessage = ''
            }
            this.errorMessage = errorMessage
          })
          .catch((error) => {
            errorMessage = `${errorMessage}. ${error}`
            this.errorMessage = errorMessage
          })
      },

      setErrorMessage(message) {
        this.errorMessage = message
      },

      setGroupsData(data) {
        this.merchantSegmentIds = data.merchant_segment_ids
        this.merchantTagIds = data.merchant_tag_ids
        this.groupsWithSelected = data.groups_with_selected
        const subConfig = data.sub_configuration
        this.subConfigMax = subConfig ? subConfig.max_date : null
        this.subConfigMin = subConfig ? subConfig.min_date : null
        data.tag_subfilters.forEach( tagSubfilter => {
          this.subfilters[tagSubfilter.tag_type] = this.formatTagSubfilterDisplay(tagSubfilter)
        })
      },
    },

    created() {
      this.loadSelectedGroups()
    },
  }
</script>
